import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';  // Importamos el entorno
import { LoginModel } from '../../models/login.model';  // Importamos la interfaz Product
import * as CryptoJS from 'crypto-js';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiUrl = environment.apiUrl;  // Usamos la URL del entorno
  private routerApi = 'api/users';  // Usamos la URL del entorno
  private secretKey = 'za63qj2p';  // Usamos la URL del entorno
  public departaments_colombia: any[] = [];
  public cities_colombia: any[] = [];
  private server_imagine_places =
  this.apiUrl+'/api/countrylibrary/es/america/COL/';
  private places_headers = new HttpHeaders({
    'Content-Type': 'application/json',
    apiKey: 'VQYHJtawdLuyqg4bDEm5kEwHnZfZ5lKW',
  });

  constructor(private http: HttpClient, private router: Router) { }

  login(email: string, password: string): Observable<LoginModel> {
    return this.http.post<LoginModel>(`${this.apiUrl}/${this.routerApi}/login`, { email, password });
  }
  setData(userData: any): void {
    const encryptedData = this.encryptData(userData);
    localStorage.setItem('userData', encryptedData);
  }
  logout(): void {
    localStorage.clear();
    this.router.navigate(['/login']);
  }
  getUserData(): any {
    const encryptedData = localStorage.getItem('userData');
    if (encryptedData) {
      return this.decryptData(encryptedData);
    }
    return null;
  }

  private encryptData(data: any): string {
    return CryptoJS.AES.encrypt(JSON.stringify(data), this.secretKey).toString();
  }

  private decryptData(data: string): any {
    const bytes = CryptoJS.AES.decrypt(data, this.secretKey);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }

  sendEmailToRecoverPassword(email: string, origin: string): any {
    return this.http.post<LoginModel>(`${this.apiUrl}/${this.routerApi}/sendEmailToRecoverPassword`, { email, origin });
  }

  changePassword(newPassword: string, token: string = ''): any {
    const type = 'web';
    const headers = new HttpHeaders({
      'Authorization': token
    });
    return this.http.post<LoginModel>(`${this.apiUrl}/${this.routerApi}/changePassword`, { newPassword, type }, { headers });
  }

  updatePasswordProfile(current: string, newPass: string): any {
    const token = this.getUserData()?.token;
    const headers = new HttpHeaders({
      'Authorization': token
    });
    return this.http.put<LoginModel>(`${this.apiUrl}/${this.routerApi}/updatePassword`, { current, newPass }, { headers });
  }

  validateTokenExpiration(token: string = ''): any {
    const headers = new HttpHeaders({
      'Authorization': token
    });
    return this.http.post<LoginModel>(`${this.apiUrl}/${this.routerApi}/validateTokenExpiration`, { token });
  }

  getUserDataById(id): any {
    const token = this.getUserData()?.token;
    const headers = new HttpHeaders({
      'Authorization': token
    });
    let params = new HttpParams();
    return this.http.get<LoginModel>(`${this.apiUrl}/${this.routerApi}/${id}`, { headers, params });
  }

  updateUser(userData: any, userId): any {
    const token = this.getUserData()?.token;
    const headers = new HttpHeaders({
      'Authorization': token
    });
    console.log(`----- ${this.apiUrl}/${this.routerApi}/${userId}`)
    return this.http.put<any>(`${this.apiUrl}/${this.routerApi}/${userId}`, userData, { headers });
  }

  public async getDepartmentFromServerImagine() {
    try {
      const resp: any = await this.http
        .get(this.server_imagine_places, {
          headers: this.places_headers,
        })
        .toPromise();
      this.departaments_colombia = resp.data;
      return resp.data;
    } catch (err) {
      console.log(err);
    }
  }
  public async getCitiesFromServerImagine(department: any) {
    try {
      const resp: any = await this.http
        .get(`${this.server_imagine_places}${department}/`, {
          headers: this.places_headers,
        })
        .toPromise();
      this.cities_colombia = resp.data;
      return resp.data;
    } catch (err) {
      console.log(err);
    }
  }

}